import React from 'react';
import { CheckIcon, CreditCardIcon, MailIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { Reveal } from './Reveal';
import { offerBonusTitles, offerExtras, price, urgency } from '../data/content';
export function Offer() {
  return <section id="comprar" className="scroll-mt-24 bg-paper-soft px-5 py-20 sm:py-28 lg:px-8" aria-labelledby="oferta" data-id="element-160" data-mp="1hpqrrswtogxl">
      <div className="mx-auto max-w-6xl" data-id="element-161" data-mp="ozryflblhxn4">
        <Reveal data-id="element-162" data-mp="p0tl6n1z48ko">
          <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-163" data-mp="p1bf3d15yapf">
            <div data-id="element-164" data-mp="13xspo21j3lax">
              <p className="text-[11px] font-extrabold uppercase tracking-[0.28em] text-grass" data-id="element-165" data-mp="13ycabqikcnsn">
                Oferta por tiempo limitado
              </p>
              <h2 id="oferta" className="display mt-4 max-w-2xl text-4xl text-ink sm:text-5xl" data-id="element-166" data-mp="2fbeokex6x19n">
                El precio de lanzamiento vence en
              </h2>
            </div>
            <CountdownTimer data-id="element-167" data-mp="pjp9jw97mqnt" />
          </div>
          <p className="mt-5 text-sm text-ink-dim" data-id="element-168" data-mp="uj1wsi3ztzqx">
            El precio de lanzamiento termina hoy. Después vuelve a $89.999.
          </p>
        </Reveal>

        <Reveal delay={0.05} data-id="element-169" data-mp="zj6egbgn10iq">
          <div className="mt-10" data-id="element-170" data-mp="13k01l2m9abak">
            <div className="flex items-center justify-between text-[11px] font-extrabold uppercase tracking-[0.2em] text-ink" data-id="element-171" data-mp="13k9rkq7awig9">
              <span data-id="element-172" data-mp="6vahr6r2j8ly">Cupos limitados — solo hoy</span>
              <span className="text-grass" data-id="element-173" data-mp="bsaqjpfaypgr">{urgency.claimedPercent}% reclamado</span>
            </div>
            <div className="mt-3 h-2.5 w-full overflow-hidden rounded-full bg-ink/10" role="progressbar" aria-valuenow={urgency.claimedPercent} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos reclamados" data-id="element-174" data-mp="ftvycwczcdk3">
              <div className="h-full rounded-full bg-grass" style={{
              width: `${urgency.claimedPercent}%`
            }} data-id="element-175" data-mp="3o9fohmictfux" />
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.08} data-id="element-176" data-mp="qfmfs9uaae0x">
          <div className="mt-10 grid gap-px overflow-hidden rounded-2xl border border-paper-line bg-paper-line lg:grid-cols-[1.15fr_0.85fr]" data-id="element-177" data-mp="qge02oifkpbw">
            <div className="bg-paper p-8 sm:p-10" data-id="element-178" data-mp="106pbsx8cw2tc">
              <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-grass" data-id="element-179" data-mp="1078xmp14nbcn">
                Megapack Entrenador 360° — paquete completo
              </p>
              <h3 className="display mt-3 text-3xl text-ink sm:text-4xl" data-id="element-180" data-mp="7itkk81k333y">
                Te vas a llevar todo esto
              </h3>

              <p className="mt-8 text-[11px] font-extrabold uppercase tracking-[0.2em] text-ink-dim" data-id="element-181" data-mp="lfgh49pljr9c">
                5 bonos especializados en fútbol
              </p>
              <ol className="mt-4 space-y-3" data-id="element-182" data-mp="1wvewswfa5bjj">
                {offerBonusTitles.map((title, i) => <li key={title} className="flex items-start gap-3" data-id="element-183" data-mp="1sucw0b5psrfg" data-mpi={i}>
                    <span className="display mt-0.5 shrink-0 text-sm text-grass" data-id="element-184" data-mp="20e47virh80kv">
                      0{i + 1}
                    </span>
                    <span className="text-[15px] font-medium leading-snug text-ink" data-id="element-185" data-mp="25f1r7yo830ny">
                      {title}
                    </span>
                  </li>)}
              </ol>

              <ul className="mt-8 space-y-3 border-t border-paper-line pt-6" data-id="element-186" data-mp="1vft1ji0e487e">
                {offerExtras.map(extra => <li key={extra} className="flex items-start gap-3 text-base font-bold text-ink" data-id="element-187" data-mp="2o48dtws50cf1">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grass" aria-hidden="true" data-id="element-188" data-mp="29espeng2wj2i" />
                    {extra}
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col justify-center bg-ink p-8 text-white sm:p-10" data-id="element-189" data-mp="36v97c5ahnfr7">
              <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-white/60" data-id="element-190" data-mp="1j64masqxkdpf">
                Valor real total: {price.was}
              </p>
              <div className="mt-3 flex items-end gap-4" data-id="element-191" data-mp="1e9e9ceaf9y88">
                <span className="display text-6xl text-grass sm:text-7xl" data-id="element-192" data-mp="1999sgn5lr1hh">
                  {price.now}
                </span>
                <span className="pb-2 text-lg text-white/45 line-through" data-id="element-193" data-mp="14ayhg93kmkxo">
                  {price.was}
                </span>
              </div>
              <p className="mt-4 inline-flex w-fit rounded-md bg-grass px-3 py-1.5 text-[13px] font-extrabold uppercase tracking-wide text-white" data-id="element-194" data-mp="1wy2o0iibb7bk">
                Ahorrás {price.savings} — {price.discount} de descuento
              </p>
              <p className="mt-4 text-sm text-white/60" data-id="element-195" data-mp="1n784vn0d4nuc">
                Pago único · acceso de por vida
              </p>

              <CtaButton size="lg" className="mt-8 w-full" data-id="element-196" data-mp="2kpgjgxbrfj0r">
                Sí, quiero el megapack
              </CtaButton>

              <p className="mt-4 text-center text-[13px] text-white/60" data-id="element-197" data-mp="2o5b49bi9ht0r">
                Protegido por la garantía de 7 días.
              </p>

              <ul className="mt-6 space-y-2 border-t border-white/10 pt-6 text-[13px] text-white/70" data-id="element-198" data-mp="2s7o7nt9jdeud">
                <li className="flex items-center gap-2" data-id="element-199" data-mp="2x57rr9sx0lu8">
                  <ShieldCheckIcon className="h-4 w-4 shrink-0 text-grass" aria-hidden="true" data-id="element-200" data-mp="324srhmfwsy80" />
                  Pago seguro con Mercado Pago
                </li>
                <li className="flex items-center gap-2" data-id="element-201" data-mp="3b4pcne33beyb">
                  <MailIcon className="h-4 w-4 shrink-0 text-grass" aria-hidden="true" data-id="element-202" data-mp="3b3ecrpcrmrch" />
                  Acceso inmediato vía mail
                </li>
                <li className="flex items-center gap-2" data-id="element-203" data-mp="3ku8xgpad5ivt">
                  <CreditCardIcon className="h-4 w-4 shrink-0 text-grass" aria-hidden="true" data-id="element-204" data-mp="3puwx1zcnr81n" />
                  Tarjeta · débito · transferencia
                </li>
              </ul>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}